import { render, staticRenderFns } from "./VideoIcon.vue?vue&type=template&id=67896a77&"
import script from "./VideoIcon.vue?vue&type=script&lang=ts&"
export * from "./VideoIcon.vue?vue&type=script&lang=ts&"
import style0 from "./VideoIcon.vue?vue&type=style&index=0&id=67896a77&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports